import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"

import { z } from "zod"
import type { TypedSchemaOutput } from "@/utils/utilityTypes"
import {
  requiredTrimmedString,
  trimmedString,
} from "@/validation/sharedStringFieldSchemas"

const productFormSchema = z.object({
  name: requiredTrimmedString("Product name is required"),
  price: z.number().int().nonnegative(),
  color: trimmedString().nullable(),
  vatRate: z
    .number()
    .multipleOf(
      0.01,
      "VAT rate must have at most 2 decimal places"
    )
    .nullable(),
  parentCategoryId: z.string().uuid().nullable(),
  hasVariablePrice: z.boolean(),
  tagIds: z.array(z.string().uuid()),
  modifierGroupIds: z.array(z.string().uuid()),
})

export type CreateUpdateProductFormOutput =
  TypedSchemaOutput<typeof productFormSchema>

export const useCreateUpdateProductForm = () =>
  useForm({
    validationSchema: toTypedSchema(productFormSchema),
    initialValues: {
      name: "",
      price: 0,
      color: null,
      parentCategoryId: null,
      vatRate: null,
      hasVariablePrice: false,
      tagIds: [],
      modifierGroupIds: [],
    },
  })
